import React from "react";
import { TbShare } from "react-icons/tb";
import BottomModal from "../bottomModal/BottomModal";
import { SaleItemInterface } from "../../types/types";
import styles from "./Share.module.scss";
import ShareModalContent from "./components/shareModalContent/ShareModalContent";
import { useShare } from "./hooks/useShare";

interface ShareProps {
  item?: Pick<SaleItemInterface, "id" | "name" | "description" | "files">;
  customUrl?: string;
  customText?: string;
}

export const Share: React.FC<ShareProps> = ({
  item,
  customUrl,
  customText,
}) => {
  const { modalActive, setModalActive, shareUrl, shareText } = useShare(
    item,
    customUrl,
    customText,
  );

  return (
    <>
      <button
        className={styles.shareButton}
        onClick={() => setModalActive(true)}
        aria-label="Поделиться"
      >
        <TbShare size={24} />
      </button>

      <BottomModal
        isVisible={modalActive}
        onClose={() => setModalActive(false)}
      >
        <ShareModalContent
          url={shareUrl}
          text={shareText}
          onClose={() => setModalActive(false)}
        />
      </BottomModal>
    </>
  );
};
